import { format } from "date-fns";
import { FilterFormSchema } from "src/Pages/Company/Pending/PendingBenefits/types";

export const prepareFilters = ({
  employee,
  benefitName,
  organizationUnitId,
  date,
  conditionType,
  barcodeIds,
}: FilterFormSchema) => ({
  employeeId: employee?.value,
  benefitName,
  organizationUnitId,
  dateFrom: date?.[0] ? format(date?.[0], "yyyy-MM-dd") : null,
  dateTo: date?.[1] ? format(date?.[1], "yyyy-MM-dd") : null,
  conditionType: Array.isArray(conditionType)
    ? conditionType.join(",")
    : conditionType,
  barcodeIds: (barcodeIds || []).length > 0 ? barcodeIds?.join(",") : null,
});
